module.exports = __webpack_public_path__ + "df2e761cb009a5fa361e283342fbdf9d.svg";